<template>
  <div
    class="header"
    data-qa="page-qmulus-header"
  >
    <div class="header__wrapper">
      <div>
        <div
          class="typo-h3"
          data-qa="page-qmulus-header__header"
        >
          <slot />
        </div>
        <div
          v-if="!!$slots.actions && hasSlotContent($slots.subheader)"
          class="typo-h6 header__subheader"
          data-qa="page-qmulus-header__subheader"
        >
          <slot name="subheader" />
        </div>
      </div>
      <div
        v-if="!!$slots.actions && hasSlotContent($slots.actions)"
        class="header__actions"
        data-qa="page-qmulus-header__actions"
      >
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  hasSlotContent,
} from '../../utils/vue.ts';
</script>

<style lang="scss">
.header {
  width: 100%;
  padding: var(--gap-section) var(--gap-section) var(--gap);
  background-color: var(--color-00);

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: solid 1px var(--primary-color);
    padding-bottom: var(--gap);
  }

  &__subheader {
    padding-top: var(--gap);
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
}
</style>
